import { customEvent, DirectEventPathType } from "goi_common";
import { postPrimeCallLead } from "@/apis/callLead";
import { useMutation } from "react-query";

export const useConsultSubmit = ({
  path,
  onSuccess,
  goBack,
}: {
  path: keyof typeof DirectEventPathType;
  onSuccess?: (id: number) => void;
  goBack?: () => void;
}) => {
  const mutation = useMutation(
    ({
      phone,
      memo,
      marketingAgree,
    }: {
      phone: string;
      memo: string;
      marketingAgree: boolean;
    }) => postPrimeCallLead(phone, memo, marketingAgree),
    {
      onSuccess: (id: number) => {
        if (typeof gtag === "function") {
          gtag("event", "click-call_lead-submit_call_lead");
        }
        customEvent({
          newGtm: {
            path,
            trigger_and_target: "submit_call_lead",
          },
        });
        onSuccess?.(id);
        goBack?.();
      },
      onError: () => {
        alert("상담 신청 중 오류가 발생했습니다.");
      },
    }
  );

  return {
    loading: mutation.isLoading,
    submitConsult: mutation.mutate,
  };
};
